import platform from '../platform/index.js';
export default platform.hasStandardBrowserEnv ? function (origin, isMSIE) {
  return function (url) {
    url = new URL(url, platform.origin);
    return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
  };
}(new URL(platform.origin), platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)) : function () {
  return true;
};